import { unavailableOnWeb } from './unavailableOnWeb.web';
/**
 * Web stub for `expo-tracking-transparency`. AppsFlyer is a no-op on web, so
 * the attribution calls that read the advertising ID never run there.
 */
export const getAdvertisingId = unavailableOnWeb('getAdvertisingId');
